module.exports = __webpack_public_path__ + "static/media/03.3a9d7574.png";